module.exports = __webpack_public_path__ + "static/img/logo-省发改委商务厅.ea96757a.png";